import type { FindingParameters } from '@telespot/domain';
import { AssetAnalysisStatus, AssetStatusSummary, RoiChange } from '../../entities';


export class AssetStatusProjectionService {
  public static project(
    baseline: AssetAnalysisStatus[],
    roiChanges: RoiChange[],
    localFindings: FindingParameters[],
    selectedAnalystId: string
  ): AssetStatusSummary {
    const analyzed = new Set<string>();
    const reviewed = new Set<string>();

    for (const item of baseline) {
      if (item.analyzed) analyzed.add(item.assetId);
      if (item.reviewed) reviewed.add(item.assetId);
    }

    if (selectedAnalystId) {
      for (const change of roiChanges) {
        if (change.creatorId === selectedAnalystId && change.assetId) {
          analyzed.add(change.assetId);
        }
      }

      for (const finding of localFindings) {
        if (finding.creatorId === selectedAnalystId && finding.assetId) {
          analyzed.add(finding.assetId);
        }
      }
    }

    return {
      analyzedAssetIds: Array.from(analyzed),
      reviewedAssetIds: Array.from(reviewed),
    };
  }
}
